<template>
  <div class="layout-page">
     <bottom></bottom>
    <div id="scroll-div-new" class="aui-scrollView">
      <swiper v-if="adList.length > 0" :ad-list="adList"></swiper>
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getBooks"
      >
       <books-large :show-title="false" :books="list"></books-large>
      </van-list>
    </div>
  </div>
</template>

<script>
import Swiper from '@/components/share/swiper'
import Bottom from '@/components/layer1/bottom'
import BooksLarge from '@/components/share/books-large'

import swiperService from '@/services/swiperService'
import listService from '@/services/listService'

export default {
  name: 'new',
  data () {
    return {
      componentName: '',
      adList: [],
      loading: false,
      finished: false,
      finishedText: '',
      list: [],
      currentPage: 1
    }
  },
  methods: {
    getBooks () {
      const { finished, currentPage, list } = this
      if (finished) return
      listService.getNewList(currentPage).then(res => {
        const resData = res.data
        const bookList = resData.bookList || []
        this.loading = false
        this.list = list.concat(bookList)
        if (currentPage >= resData.totalPage || bookList.length === 0) {
          this.finished = true
          if (this.list.length > 6) {
            this.finishedText = '没有更多了'
          } else {
            this.finishedText = ''
          }
        } else {
          this.currentPage++
        }
      })
    },
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    }
  },
  components: {
    swiper: Swiper,
    Bottom,
    'books-large': BooksLarge
  },
  mounted () {
    this.componentName = this.$route.name
    if (
      this.$store.state.pageState[this.componentName]
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.$route.name].data
      )
      setTimeout(() => {
        const scrollDiv = document.getElementById('scroll-div-new')
        scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top
      }, 5)
    } else {
      this.adList = swiperService.getAdList()
    }
    this.$router.isBack = true
  },
  beforeDestroy () {
    const scrollDiv = document.getElementById('scroll-div-new')
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped>
</style>
